import { createContext, type ReactElement, type ReactNode, useContext } from 'react';

import type { ColumnDraft, FilteredColumnRow } from '../types';

export type ColumnEditorContextValue = {
  counts: { all: number; customer: number; contract: number; ignore: number };
  searchText: string;
  setSearchText: (v: string) => void;
  destinationFilter: 'all' | ColumnDraft['destination'];
  setDestinationFilter: (v: 'all' | ColumnDraft['destination']) => void;
  filteredColumns: FilteredColumnRow[];
  filteredAllSelected: boolean;
  selectedNames: Set<string>;
  toggleRowSelection: (name: string, checked: boolean) => void;
  toggleSelectAllFiltered: (checked: boolean) => void;
  clearColumnSelection: () => void;
  updateColumn: (index: number, patch: Partial<ColumnDraft>) => void;
  bulkSetDestination: (d: ColumnDraft['destination']) => void;
  contractColumnNames: string[];
  customerColumnNames: string[];
  customerUkEnabled: boolean;
};

const ColumnEditorContext = createContext<ColumnEditorContextValue | null>(null);

type ColumnEditorProviderProps = {
  value: ColumnEditorContextValue;
  children: ReactNode;
};

export function ColumnEditorProvider({ value, children }: ColumnEditorProviderProps): ReactElement {
  return <ColumnEditorContext.Provider value={value}>{children}</ColumnEditorContext.Provider>;
}

export function useColumnEditor(): ColumnEditorContextValue {
  const ctx = useContext(ColumnEditorContext);
  if (ctx === null) {
    throw new Error('useColumnEditor must be used inside <ColumnEditorProvider>');
  }
  return ctx;
}
